export const environment = {
  production: false,
  mode: 'development',
  siteUrl: 'https://dev.frantinco-ai.com',
  absensiUrl: 'https://dev.absen.frantinco-ai.com/'
};
